import React from 'react';

import { ValidatorFactory } from 'components/common';

// A number whose unit is entered in the same control: where NumberWithUnitInput prints the unit as a
// read-only label in its grey addon, this one makes that addon the picker.
//
// It knows nothing about which units it is showing. The caller passes the whole list, so
// [sheet, product] and [mm, in] are the same case as far as this component is concerned -- there is
// no naming convention, prefix or translation rule baked in here; labels arrive already resolved.
//
// The number handling below is deliberately a copy of NumberWithUnitInput's rather than an extraction
// from it: that component is used by the redraw material choosers and the quote builder widget, and
// leaving it untouched is what keeps those callers provably unaffected by this one.
const NumberWithStaticUnitsInput = (props) => {
  const validate = (val) => {

    if(props.validators != undefined) {
      for(let i=0; i< props.validators.length; i++) {
        let validator = props.validators[i];
        if(!(ValidatorFactory(validator, val) || ValidatorFactory(validator, props.value)) ) {
          return t(`quote_builder.validator_${validator}_message`);
        }
      }
    }

    if(props.value >= 0 ) { return; }
    if(val < 0) { return t('quote_builder.please_enter_a_valid_value'); }
  }

  const formatValue = (e) => {
    props.integerOnly ? formatValueInteger(e.target.value) : formatValueDecimal(e.target.value);
  }

  const formatValueDecimal = (value) => {
    if(props.integerOnly) { return; }
    let toFormat = parseFloat(value);
    let formatted = (Number.isNaN(toFormat) ? 0 : toFormat).toFixed(2);
    let ev = { target: { value: formatted} };
    props.onChange(ev);
  }

  const formatValueInteger = (value) => {
    if(!props.integerOnly) { return; }

    let toFormat = parseFloat(value);
    let formatted = (Number.isNaN(toFormat) ? 0 : toFormat).toFixed(0);
    let ev = { target: { value: formatted} };
    props.onChange(ev);
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      props.onChange(e);
    }
  }

  return (
    <>
      <div className={`input-group number_input ${props.class_name != undefined ? props.class_name : 'general-frm-element'}`}>
        <input
          type="number"
          onWheel={(e) => e.target.blur()}
          className={`${props.errors[props.name] ? 'input-error form-control' : 'form-control'} ${props.class_name != undefined ? props.class_name : 'general-frm-element'}`}
          size="10"
          autoComplete="off"
          placeholder={props.placeholder}
          name={props.name}
          readOnly={props.readOnly}
          step={props.integerOnly ? '1' : '0.1'}
          value={props.value}
          onKeyDown={handleKeyDown}
          {...props.register(props.name, {
            required: window.t_price_calculator_required,
            validate: validate,
            onChange: props.onChange,
            onBlur: formatValue,
          })}
          />

        {/* Everywhere else in the app a grey addon is a read-only unit label, so this one has to say
            it can be changed: a pencil, a dotted underline under the value, and an addon that
            responds to the pointer. The pencil sits inside the select's own box (see the padding in
            .input-group-addon-select) because a native picker cannot be opened from script -- a click
            has to land on the select itself. */}
        <span className={`${props.errors[props.name] ? 'input-error input-group-addon' : 'input-group-addon'} input-group-addon-editable`}>
          <span className="input-group-addon-select-wrapper">
            <select
              className="input-group-addon-select"
              name={props.unitName}
              value={props.unitValue}
              disabled={props.unitDisabled}
              aria-label={props.unitAriaLabel}
              onChange={props.onUnitChange}
              >
              {props.unitOptions.map((unitOption) => {
                return <option
                  key={unitOption.value}
                  value={unitOption.value}> {unitOption.label}
                </option>
              })}
            </select>
            <i className="fa fa-pencil input-group-addon-select-icon" aria-hidden="true"></i>
          </span>
        </span>
      </div>
      {props.errors[props.name] && <small className="error"> {props.errors[props.name].message} </small> }
    </>
  )
}

export default NumberWithStaticUnitsInput
